// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * ChunkErrorBoundary Styles
 *
 * Full-screen error/loading states for chunk loading failures.
 * Clean, professional design with smooth animations.
 */

.chunk-error-boundary {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 99999;
  padding: 20px;
}

.chunk-error-boundary--error {
  background: linear-gradient(135deg, #ffeaa7 0%, #fdcb6e 100%);
}

.chunk-error-boundary__content {
  max-width: 500px;
  text-align: center;
  animation: fadeInScale 0.4s cubic-bezier(0.16, 1, 0.3, 1);
}

@keyframes fadeInScale {
  from {
    opacity: 0;
    transform: scale(0.9);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

/* Spinner styles */
.chunk-error-boundary__spinner {
  margin: 0 auto 24px;
  width: 64px;
  height: 64px;
}

.chunk-error-boundary__spinner-svg {
  animation: rotate 2s linear infinite;
  width: 100%;
  height: 100%;
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.chunk-error-boundary__spinner-circle {
  stroke: #667eea;
  stroke-linecap: round;
  animation: dash 1.5s ease-in-out infinite;
}

@keyframes dash {
  0% {
    stroke-dasharray: 1, 150;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -35;
  }
  100% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -124;
  }
}

/* Error icon */
.chunk-error-boundary__icon {
  margin: 0 auto 24px;
  color: #d63031;
}

/* Text styles */
.chunk-error-boundary__title {
  margin: 0 0 16px 0;
  font-size: 24px;
  font-weight: 700;
  color: #2d3436;
  letter-spacing: -0.02em;
}

.chunk-error-boundary__message {
  margin: 0 0 24px 0;
  font-size: 16px;
  line-height: 1.6;
  color: #636e72;
}

/* Action buttons */
.chunk-error-boundary__actions {
  display: flex;
  gap: 12px;
  justify-content: center;
  margin-top: 24px;
}

.chunk-error-boundary__button {
  padding: 12px 24px;
  border: none;
  border-radius: 8px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  font-family: inherit;
}

.chunk-error-boundary__button:focus {
  outline: 2px solid #667eea;
  outline-offset: 2px;
}

.chunk-error-boundary__button:active {
  transform: translateY(1px);
}

.chunk-error-boundary__button--primary {
  background: #667eea;
  color: white;
}

.chunk-error-boundary__button--primary:hover {
  background: #5568d3;
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(102, 126, 234, 0.4);
}

.chunk-error-boundary__button--secondary {
  background: white;
  color: #667eea;
  border: 2px solid #667eea;
}

.chunk-error-boundary__button--secondary:hover {
  background: #f5f7fa;
}

/* Error details (development only) */
.chunk-error-boundary__details {
  margin-top: 24px;
  text-align: left;
  background: white;
  border-radius: 8px;
  padding: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.chunk-error-boundary__details summary {
  cursor: pointer;
  font-weight: 600;
  color: #2d3436;
  margin-bottom: 12px;
}

.chunk-error-boundary__details summary:hover {
  color: #667eea;
}

.chunk-error-boundary__error-stack {
  margin: 12px 0 0 0;
  padding: 12px;
  background: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  font-size: 12px;
  line-height: 1.5;
  color: #495057;
  overflow-x: auto;
  white-space: pre-wrap;
  word-wrap: break-word;
}

/* Responsive design */
@media (max-width: 640px) {
  .chunk-error-boundary {
    padding: 16px;
  }

  .chunk-error-boundary__content {
    max-width: 100%;
  }

  .chunk-error-boundary__title {
    font-size: 20px;
  }

  .chunk-error-boundary__message {
    font-size: 14px;
  }

  .chunk-error-boundary__actions {
    flex-direction: column;
  }

  .chunk-error-boundary__button {
    width: 100%;
  }

  .chunk-error-boundary__spinner {
    width: 48px;
    height: 48px;
  }

  .chunk-error-boundary__icon svg {
    width: 48px;
    height: 48px;
  }
}

/* Accessibility: Reduced motion */
@media (prefers-reduced-motion: reduce) {
  .chunk-error-boundary__content {
    animation: fadeIn 0.3s ease-in;
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  .chunk-error-boundary__spinner-svg {
    animation: none;
  }

  .chunk-error-boundary__spinner-circle {
    animation: none;
    stroke-dasharray: 90, 150;
  }

  .chunk-error-boundary__button {
    transition: none;
  }
}

/* Dark mode support */
@media (prefers-color-scheme: dark) {
  .chunk-error-boundary {
    background: linear-gradient(135deg, #2d3436 0%, #000000 100%);
  }

  .chunk-error-boundary--error {
    background: linear-gradient(135deg, #fdcb6e 0%, #e17055 100%);
  }

  .chunk-error-boundary__title {
    color: #ffffff;
  }

  .chunk-error-boundary__message {
    color: #b2bec3;
  }

  .chunk-error-boundary__details {
    background: #2d3436;
    border-color: #636e72;
  }

  .chunk-error-boundary__details summary {
    color: #ffffff;
  }

  .chunk-error-boundary__error-stack {
    background: #000000;
    border-color: #636e72;
    color: #dfe6e9;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ChunkErrorBoundary/ChunkErrorBoundary.css"],"names":[],"mappings":"AAAA;;;;;EAKE;;AAEF;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,6DAA6D;EAC7D,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,yDAAyD;AAC3D;;AAEA;EACE;IACE,UAAU;IACV,qBAAqB;EACvB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA,mBAAmB;AACnB;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,WAAW;EACX,YAAY;AACd;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA;EACE;IACE,wBAAwB;IACxB,oBAAoB;EACtB;EACA;IACE,yBAAyB;IACzB,sBAAsB;EACxB;EACA;IACE,yBAAyB;IACzB,uBAAuB;EACzB;AACF;;AAEA,eAAe;AACf;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iDAAiD;EACjD,oBAAoB;AACtB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA,qCAAqC;AACrC;EACE,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,wCAAwC;AAC1C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA,kCAAkC;AAClC;EACE;IACE,8BAA8B;EAChC;;EAEA;IACE;MACE,UAAU;IACZ;IACA;MACE,UAAU;IACZ;EACF;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,yBAAyB;EAC3B;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA,sBAAsB;AACtB;EACE;IACE,6DAA6D;EAC/D;;EAEA;IACE,6DAA6D;EAC/D;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,qBAAqB;EACvB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;EAChB;AACF","sourcesContent":["/**\n * ChunkErrorBoundary Styles\n *\n * Full-screen error/loading states for chunk loading failures.\n * Clean, professional design with smooth animations.\n */\n\n.chunk-error-boundary {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 99999;\n  padding: 20px;\n}\n\n.chunk-error-boundary--error {\n  background: linear-gradient(135deg, #ffeaa7 0%, #fdcb6e 100%);\n}\n\n.chunk-error-boundary__content {\n  max-width: 500px;\n  text-align: center;\n  animation: fadeInScale 0.4s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n@keyframes fadeInScale {\n  from {\n    opacity: 0;\n    transform: scale(0.9);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n/* Spinner styles */\n.chunk-error-boundary__spinner {\n  margin: 0 auto 24px;\n  width: 64px;\n  height: 64px;\n}\n\n.chunk-error-boundary__spinner-svg {\n  animation: rotate 2s linear infinite;\n  width: 100%;\n  height: 100%;\n}\n\n@keyframes rotate {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.chunk-error-boundary__spinner-circle {\n  stroke: #667eea;\n  stroke-linecap: round;\n  animation: dash 1.5s ease-in-out infinite;\n}\n\n@keyframes dash {\n  0% {\n    stroke-dasharray: 1, 150;\n    stroke-dashoffset: 0;\n  }\n  50% {\n    stroke-dasharray: 90, 150;\n    stroke-dashoffset: -35;\n  }\n  100% {\n    stroke-dasharray: 90, 150;\n    stroke-dashoffset: -124;\n  }\n}\n\n/* Error icon */\n.chunk-error-boundary__icon {\n  margin: 0 auto 24px;\n  color: #d63031;\n}\n\n/* Text styles */\n.chunk-error-boundary__title {\n  margin: 0 0 16px 0;\n  font-size: 24px;\n  font-weight: 700;\n  color: #2d3436;\n  letter-spacing: -0.02em;\n}\n\n.chunk-error-boundary__message {\n  margin: 0 0 24px 0;\n  font-size: 16px;\n  line-height: 1.6;\n  color: #636e72;\n}\n\n/* Action buttons */\n.chunk-error-boundary__actions {\n  display: flex;\n  gap: 12px;\n  justify-content: center;\n  margin-top: 24px;\n}\n\n.chunk-error-boundary__button {\n  padding: 12px 24px;\n  border: none;\n  border-radius: 8px;\n  font-size: 15px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n  font-family: inherit;\n}\n\n.chunk-error-boundary__button:focus {\n  outline: 2px solid #667eea;\n  outline-offset: 2px;\n}\n\n.chunk-error-boundary__button:active {\n  transform: translateY(1px);\n}\n\n.chunk-error-boundary__button--primary {\n  background: #667eea;\n  color: white;\n}\n\n.chunk-error-boundary__button--primary:hover {\n  background: #5568d3;\n  transform: translateY(-2px);\n  box-shadow: 0 6px 16px rgba(102, 126, 234, 0.4);\n}\n\n.chunk-error-boundary__button--secondary {\n  background: white;\n  color: #667eea;\n  border: 2px solid #667eea;\n}\n\n.chunk-error-boundary__button--secondary:hover {\n  background: #f5f7fa;\n}\n\n/* Error details (development only) */\n.chunk-error-boundary__details {\n  margin-top: 24px;\n  text-align: left;\n  background: white;\n  border-radius: 8px;\n  padding: 16px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n.chunk-error-boundary__details summary {\n  cursor: pointer;\n  font-weight: 600;\n  color: #2d3436;\n  margin-bottom: 12px;\n}\n\n.chunk-error-boundary__details summary:hover {\n  color: #667eea;\n}\n\n.chunk-error-boundary__error-stack {\n  margin: 12px 0 0 0;\n  padding: 12px;\n  background: #f8f9fa;\n  border: 1px solid #dee2e6;\n  border-radius: 4px;\n  font-size: 12px;\n  line-height: 1.5;\n  color: #495057;\n  overflow-x: auto;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n}\n\n/* Responsive design */\n@media (max-width: 640px) {\n  .chunk-error-boundary {\n    padding: 16px;\n  }\n\n  .chunk-error-boundary__content {\n    max-width: 100%;\n  }\n\n  .chunk-error-boundary__title {\n    font-size: 20px;\n  }\n\n  .chunk-error-boundary__message {\n    font-size: 14px;\n  }\n\n  .chunk-error-boundary__actions {\n    flex-direction: column;\n  }\n\n  .chunk-error-boundary__button {\n    width: 100%;\n  }\n\n  .chunk-error-boundary__spinner {\n    width: 48px;\n    height: 48px;\n  }\n\n  .chunk-error-boundary__icon svg {\n    width: 48px;\n    height: 48px;\n  }\n}\n\n/* Accessibility: Reduced motion */\n@media (prefers-reduced-motion: reduce) {\n  .chunk-error-boundary__content {\n    animation: fadeIn 0.3s ease-in;\n  }\n\n  @keyframes fadeIn {\n    from {\n      opacity: 0;\n    }\n    to {\n      opacity: 1;\n    }\n  }\n\n  .chunk-error-boundary__spinner-svg {\n    animation: none;\n  }\n\n  .chunk-error-boundary__spinner-circle {\n    animation: none;\n    stroke-dasharray: 90, 150;\n  }\n\n  .chunk-error-boundary__button {\n    transition: none;\n  }\n}\n\n/* Dark mode support */\n@media (prefers-color-scheme: dark) {\n  .chunk-error-boundary {\n    background: linear-gradient(135deg, #2d3436 0%, #000000 100%);\n  }\n\n  .chunk-error-boundary--error {\n    background: linear-gradient(135deg, #fdcb6e 0%, #e17055 100%);\n  }\n\n  .chunk-error-boundary__title {\n    color: #ffffff;\n  }\n\n  .chunk-error-boundary__message {\n    color: #b2bec3;\n  }\n\n  .chunk-error-boundary__details {\n    background: #2d3436;\n    border-color: #636e72;\n  }\n\n  .chunk-error-boundary__details summary {\n    color: #ffffff;\n  }\n\n  .chunk-error-boundary__error-stack {\n    background: #000000;\n    border-color: #636e72;\n    color: #dfe6e9;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
